/**
 * @file Identity selection list.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IdentityAvatarContainer from '../../../containers/global/identity/IdentityAvatarContainer';
import IdentityName from '../../../containers/global/identity/IdentityNameContainer';

const propTypes = {
  identities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      last_name: PropTypes.string,
      current_photo: PropTypes.shape({
        id: PropTypes.string,
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
          }),
        ),
      }),
    }),
  ),
  onIdentitySelect: PropTypes.func.isRequired,
  selectedIdentityIds: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  renderItemChild: PropTypes.func,
};

const defaultProps = {
  identities: [],
  selectedIdentityIds: [],
};

const IdentitySelectList = ({
  identities,
  onIdentitySelect,
  selectedIdentityIds,
  className,
  itemClassName,
  renderItemChild,
}) => {
  const classes = classNames({
    'flex-list': true,
    [className]: !!className,
  });

  const itemClasses = classNames({
    'identity-select-item flex-list-item': true,
    'text-color-base': true,
    [itemClassName]: !!itemClassName,
  });

  return (
    <div className={classes}>
      {identities.map(identity => {
        const isSelected = selectedIdentityIds.includes(identity.id);

        return (
          <a
            key={identity.id}
            href="#"
            className={`${itemClasses} ${isSelected ? 'is-selected' : ''}`}
            onClick={event => {
              event.preventDefault();
              onIdentitySelect(identity.id);
            }}
          >
            <div className="mr-3">
              <IdentityAvatarContainer identity={identity} />
            </div>

            <IdentityName identity={identity} />

            {renderItemChild && renderItemChild(identity)}
          </a>
        );
      })}
    </div>
  );
};

IdentitySelectList.propTypes = propTypes;
IdentitySelectList.defaultProps = defaultProps;

export default IdentitySelectList;
